import { AutenticacionService } from './../../../services/autenticacion.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $;

@Component({
  selector: 'app-cerrar-session-modal',
  templateUrl: './cerrar-session-modal.component.html',
  styleUrls: ['./cerrar-session-modal.component.scss']
})
export class CerrarSessionModalComponent implements OnInit {
  public processing: boolean;
  constructor(private authService: AutenticacionService, private router: Router) {
    this.processing = false;
  }

  ngOnInit() {
  }

  reset() {
    this.processing = false;
    this.close();
  }

  open() {
    $('#cerrarSessionModal').modal('show');
  }

  close() {
    $('#cerrarSessionModal').modal('hide');
  }

  logout() {
    this.processing = true;
    this.authService.logout().subscribe(
      (response) => {
        console.log('logout - response ', response);
        this.authService.setUser(undefined);
        this.router.navigate(['login']);
        localStorage.clear();
        this.reset();
      }, (error) => {
        console.log('logout - error ', error);
        this.reset();
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/partials/cerrar-session-modal/cerrar-session-modal.component.ts